(() => {
 if (window.nutraceneTrustStripReady) return;
 window.nutraceneTrustStripReady = true;
 const observed = new WeakSet();
 const resize = new ResizeObserver(entries => entries.forEach(({target}) => {
   const group = target.querySelector('.scrolling-text-repeater');
   if (!group || !target.clientWidth) return;
   const speed = Number(getComputedStyle(target).getPropertyValue('--trust-speed')) || 20;
   target.style.setProperty('--trust-duration', (group.offsetWidth * 2 * speed / target.clientWidth) + 's');
 }));
 function initialize(root = document) {
   root.querySelectorAll('.nutracene-trust-strip').forEach(strip => {
     if (observed.has(strip)) return;
     observed.add(strip);
     resize.observe(strip);
   });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
 else initialize();
 document.addEventListener('shopify:section:load', event => initialize(event.target));
})();